import React from "react";
// import CardItem from "../../common/card/card";
import DialogComp from "../../common/dialog/dice/diceComp";
import SuitComp from "../../common/dialog/suit/suitComp";
import "./InsideTable.scss";
import DownCards from "../DownCards/DownCards";
import Deck from "../deck/Deck";
function InsideTable({ twoVstwo }) {
  return (
    <div>
      <div className="itable">
        {!twoVstwo ? <Deck /> : null}
        <DownCards twoVstwo={twoVstwo} />
        <div>
          <DialogComp />
        </div>
        <div>
          <SuitComp />
        </div>
        <div className="deck"></div>
      </div>
    </div>
  );
}

export default InsideTable;
